import { type ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { ProjectAccessProvider } from './contexts/ProjectAccessContext';

export default function ProjectAccessLayout(): ReactNode {
    return (
        <ProjectAccessProvider>
            <Outlet />
        </ProjectAccessProvider>
    );
}
